// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3iHZz","selects":"Documents_selects__2NrBx"};